module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAMAAABo+94fAAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMAfxH59cO4s24j7uncdlBI5NGLbyjFqKafUz89Lx0bBdNVFLsAAACYSURBVBjTZY8JDoQgDEW/BUHcdZx96/1PqUViY3gJafP4tAEb1M9+amrmupn83BOEcDN8wtwDMFjOsANGqWP3/tIftDwf8WmLGP7gYIhxuHgJlOV+0G7CIThb9wCY94NXY31AouBIAUWt+MyqV2sqosokr9mLdF3K6wSSlnSOWNWHl6pDdgDIGl0ZsfJrzvAAlqs5S+t+WAH5ZxnmEl3G5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/whitePhone.png
// module id = cvzF
// module chunks = 1